import React from 'react'

const Schedule = () => (
  <svg
    id="b07e16be-2c10-4721-ba95-38a6ee556ecd"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1132.39 767.13"
  >
    <defs>
      <linearGradient
        id="f0ea422a-a980-4a9e-8fad-43c87f6ba738"
        x1="421.86"
        y1="330.48"
        x2="421.86"
        y2="285.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="gray" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
        <stop offset="1" stop-color="gray" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="ad2c5ae7-cdf4-4789-99a0-6bde37321e66"
        x1="516.9"
        y1="320.8"
        x2="516.9"
        y2="276.14"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="af61e5a9-3371-4284-9366-60d451e53b7c"
        x1="699.9"
        y1="472.8"
        x2="699.9"
        y2="428.14"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="afe800ea-76fc-42fa-87d3-444aeaebb97e"
        x1="293.63"
        y1="250.89"
        x2="293.63"
        y2="206.23"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="a0a14e29-1e29-4199-9658-2a5ebd9bc7a2"
        x1="385.29"
        y1="314.89"
        x2="385.29"
        y2="270.23"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="b9eaa648-e9e9-4a67-ba92-603c001fbd1d"
        x1="753.86"
        y1="472.48"
        x2="753.86"
        y2="427.82"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="f05d82f5-c8d6-44fc-8266-fef5229bfdcd"
        x1="834.86"
        y1="251.48"
        x2="834.86"
        y2="206.82"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="fed5a35b-50d2-4029-b1da-9e4ece87a2f7"
        x1="829.86"
        y1="393.48"
        x2="829.86"
        y2="348.82"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="a057bd9d-3da5-4ef9-9b1f-12de91a9714e"
        x1="864.86"
        y1="403.48"
        x2="864.86"
        y2="358.82"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="eb119f49-f305-49d7-b722-178b1b910dac"
        x1="717.29"
        y1="456.89"
        x2="717.29"
        y2="412.23"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="f18d0c9f-76a8-47d5-9395-c2e15513d6af"
        x1="722.29"
        y1="321.89"
        x2="722.29"
        y2="277.23"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="e96273f1-ace8-4241-9189-48d1ceb051fa"
        x1="122.28"
        y1="564.8"
        x2="344.94"
        y2="564.8"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
      <linearGradient
        id="fa251bcb-f561-47ff-8b25-b5a12635a0f6"
        x1="277.86"
        y1="393.48"
        x2="277.86"
        y2="348.82"
        xlinkHref="#f0ea422a-a980-4a9e-8fad-43c87f6ba738"
      />
    </defs>
    <title>schedule</title>
    <path
      d="M646.49,178.73C576.9,178.62,509.85,157,445.7,132.94S317.91,82.05,249.58,70.54c-44-7.4-93.9-6.9-128.17,19.38C88.44,115.21,79,157.18,74.48,196c-3.39,29.18-4.91,59.83,8.17,86.57,9.09,18.57,24.59,33.89,35.56,51.6,38.17,61.6,15.52,140-21.24,202.82C79.72,566.4,59.51,594.63,46.5,625.79s-18.28,66.52-4.84,97.35C55,753.71,85,776,117.09,791.21c65.29,31,141.16,37.82,215,40.59C495.57,837.94,659.3,827,822.6,816c60.43-4.06,121.13-8.16,180.29-20.29,32.85-6.73,66.66-16.76,89.9-38.92,29.5-28.12,35.42-74.17,13.81-107.34C1070.34,593.76,975.18,583,949.08,522.82c-14.37-33.13-2.17-71,15.86-102.86,38.69-68.29,105.44-129.37,106.35-205.89.62-52.56-34.33-103.93-86.37-126.93C930.36,63,856.12,68.94,818.09,113.42,778.93,159.22,707.94,178.83,646.49,178.73Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
      opacity="0.1"
    />
    <path
      d="M992.65,692.43s-12.29-8.11-24.47-2.34c0,0,3.75,7.23,19.17,6.54Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M994.16,692.87s3.74,14.24-5.63,23.93c0,0-5.64-5.88,0-20.26Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1009.49,679.2s-.91-12.12-28.25-8.1c0,0-.13,7.82,9.47,11.52S1004.7,683.2,1009.49,679.2Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1011.17,679.11s11.57,3.72,1.26,29.37c0,0-7.63-1.71-9-11.91S1006.16,682.83,1011.17,679.11Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1026.66,661.93s1.56-19.93-26.39-17.88c0,0-2,18,21.45,22.67Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1045.13,639.43s-3.84-22.58-31.77-15.85c0,0-.11,19.53,27.2,21.24Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1058.62,616.17s-6.41-22-34.09-15.41c0,0,6.58,19.78,32.25,19.48Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1071.44,593.46s-6.27-22.83-33-16c0,0,8.92,21.69,31.24,19.87Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1079.71,571.88S1074.89,544,1050,550.14c0,0,7.24,25.4,27.9,25.8Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1087.45,545.81s-5.78-28.15-31-20c0,0,9.89,26.59,29.22,23.84Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1092.25,521.54s-9.19-28.14-28.68-27.38c0,0,9.4,29.73,27,33Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1095.3,497.87s-10-33.88-25.86-31.27c0,0,6.92,25.9,25.3,36.54Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1097,469.59s-9.37-28.24-25-29.36c0,0,6.38,27.78,24.68,36.69Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1098.93,443.26s-11.69-28.27-22-28.9c0,0,5.07,27.82,21,33.54Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1100.22,418.74S1093,388,1082.7,385.5c0,0,1.42,25.1,16.49,35.53Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1104.11,386.65s-7.56-24.46-15.93-28.19c0,0,1.66,28.84,14,34.18Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1107.34,365.58l1.53-43.14s-15.62,32.55-2.68,50.75Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1119.43,322.71s11.26-31.51,14-33.26c0,0-22.1,20.43-19.94,46.73Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1027.42,661.79s19.82-2.6,19.22,25.42c0,0-17.91,2.91-23.75-20.25Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1046.06,638.68s22.91-.08,21,28.6c0,0-19.22,3.43-25.57-23.19Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1058.84,618s20.79-9.75,34.1,15.41c0,0-19.21,8.13-35.93-11.35Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1071.91,593.67s21.28-10.38,33.78,14.21c0,0-22.17,7.64-35.54-10.32Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1079.44,572.48s20.49-19.57,36.84.23c0,0-20.93,16.1-37.79,4.13Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1086.29,545.14s20.62-20,36.84.92c0,0-23.14,16.43-37.57,3.28Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1090.15,520.74s15.88-25,34.57-19.41c0,0-16.47,26.47-34.39,25.29Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1094.83,497.71s16-31.49,31.13-26c0,0-11.53,24.2-31.54,31.31Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1095.93,468s16.45-24.78,31.86-21.76c0,0-13.44,25.13-33.45,28.93Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1097.19,442.7s12.74-27.8,23.11-28.05c0,0-6.12,27.62-22.26,32.73Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1099.71,418.13s14.17-28.16,24.82-28.21c0,0-7.25,24.07-24.34,30.69Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1101.85,388.38s10.6-23.3,19.37-25.94c0,0-5.3,28.4-18.21,32.12Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1108.61,364.76l23.68-36.08s-6.06,35.59-27.14,43Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1124.87,325.61s27.53-19,28.52-22.08c0,0-14,26.62-40,31.32Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1126.51,317.06s31.61-30.39,39.68-30.35c0,0-26.07,1.19-40.44,28.73Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M1102.15,392.89l1.15.15c5.94-46.5,14.6-74,24.39-77.38l-.38-1.09C1116.94,318.17,1108.24,345.25,1102.15,392.89Z"
      transform="translate(-33.81 -66.43)"
      fill="#444053"
    />
    <path
      d="M1093.42,504.06l1.74.15c.36-4.34.64-8.79.83-13.21,1.66-38.49,4.24-73.82,7.62-100.31l-1-1.25c-3.39,26.54-6.69,62.95-8.35,101.48C1094.06,495.32,1093.78,499.74,1093.42,504.06Z"
      transform="translate(-33.81 -66.43)"
      fill="#444053"
    />
    <path
      d="M960.19,714.57c.31-.14,30.94-13.81,62.73-46.44a252.42,252.42,0,0,0,45.85-65c14.69-29.93,23.65-66.71,26.66-102.44l-1.81.85c-6.75,80.19-43.26,135-72.3,164.84-31.48,32.34-61.76,45.88-62.06,46Z"
      transform="translate(-33.81 -66.43)"
      fill="#444053"
    />
    <path
      d="M1082.52,115.31H121.64a8.56,8.56,0,0,0-8.56,8.56v24.94h978V123.87A8.56,8.56,0,0,0,1082.52,115.31Z"
      transform="translate(-33.81 -66.43)"
      fill="#3f3d56"
    />
    <path
      d="M113.08,148.81V710.05a17.26,17.26,0,0,0,17.26,17.26h943.48a17.26,17.26,0,0,0,17.26-17.26V148.81Z"
      transform="translate(-33.81 -66.43)"
      fill="#fff"
    />
    <circle cx="94.77" cy="65.37" r="4" fill="#fa5959" opacity="0.8" />
    <circle cx="105.77" cy="65.37" r="4" fill="#fed253" opacity="0.8" />
    <circle cx="116.77" cy="65.37" r="4" fill="#8ccf4d" opacity="0.8" />
    <g opacity="0.3">
      <rect
        x="116.77"
        y="116.37"
        width="904"
        height="510"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="234.77"
        y="116.37"
        width="668"
        height="510"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="352.77"
        y="116.37"
        width="432"
        height="510"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="470.77"
        y="116.37"
        width="196"
        height="510"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <line
        x1="568.77"
        y1="116.37"
        x2="568.77"
        y2="626.37"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="116.77"
        y="190.37"
        width="904"
        height="362"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="116.77"
        y="263.37"
        width="904"
        height="216"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="116.77"
        y="336.37"
        width="904"
        height="70"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
    </g>
    <rect
      x="258.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="147.27"
      y="215.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="373.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="481.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="581.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="693.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="807.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="928.27"
      y="144.87"
      width="71"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="398.79"
      y="285.82"
      width="46.13"
      height="44.66"
      fill="url(#f0ea422a-a980-4a9e-8fad-43c87f6ba738)"
    />
    <rect x="399.59" y="286.59" width="44.54" height="43.12" fill="#7cfcff" />
    <rect
      x="493.83"
      y="276.14"
      width="46.13"
      height="44.66"
      fill="url(#ad2c5ae7-cdf4-4789-99a0-6bde37321e66)"
    />
    <rect x="494.63" y="276.91" width="44.54" height="43.12" fill="#ffffa5" />
    <rect
      x="676.83"
      y="428.14"
      width="46.13"
      height="44.66"
      fill="url(#af61e5a9-3371-4284-9366-60d451e53b7c)"
    />
    <rect x="677.63" y="428.91" width="44.54" height="43.12" fill="#ffffa5" />
    <rect
      x="270.57"
      y="206.23"
      width="46.13"
      height="44.66"
      fill="url(#afe800ea-76fc-42fa-87d3-444aeaebb97e)"
    />
    <rect x="271.36" y="207" width="44.54" height="43.12" fill="#ffffa5" />
    <rect
      x="362.23"
      y="270.23"
      width="46.13"
      height="44.66"
      fill="url(#a0a14e29-1e29-4199-9658-2a5ebd9bc7a2)"
    />
    <rect x="363.02" y="271" width="44.54" height="43.12" fill="#ff69b4" />
    <rect
      x="730.79"
      y="427.82"
      width="46.13"
      height="44.66"
      fill="url(#b9eaa648-e9e9-4a67-ba92-603c001fbd1d)"
    />
    <rect x="731.59" y="428.59" width="44.54" height="43.12" fill="#7cfcff" />
    <rect
      x="811.79"
      y="206.82"
      width="46.13"
      height="44.66"
      fill="url(#f05d82f5-c8d6-44fc-8266-fef5229bfdcd)"
    />
    <rect x="812.59" y="207.59" width="44.54" height="43.12" fill="#7cfcff" />
    <rect
      x="806.79"
      y="348.82"
      width="46.13"
      height="44.66"
      fill="url(#fed5a35b-50d2-4029-b1da-9e4ece87a2f7)"
    />
    <rect x="807.59" y="349.59" width="44.54" height="43.12" fill="#7cfcff" />
    <rect
      x="841.79"
      y="358.82"
      width="46.13"
      height="44.66"
      fill="url(#a057bd9d-3da5-4ef9-9b1f-12de91a9714e)"
    />
    <rect x="842.59" y="359.59" width="44.54" height="43.12" fill="#7cfcff" />
    <rect
      x="694.23"
      y="412.23"
      width="46.13"
      height="44.66"
      fill="url(#eb119f49-f305-49d7-b722-178b1b910dac)"
    />
    <rect x="695.02" y="413" width="44.54" height="43.12" fill="#ff69b4" />
    <rect
      x="699.23"
      y="277.23"
      width="46.13"
      height="44.66"
      fill="url(#f18d0c9f-76a8-47d5-9395-c2e15513d6af)"
    />
    <rect x="700.02" y="278" width="44.54" height="43.12" fill="#ff69b4" />
    <rect
      x="147.27"
      y="285.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="147.27"
      y="358.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="147.27"
      y="431.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="147.27"
      y="504.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <rect
      x="147.27"
      y="577.87"
      width="53"
      height="26"
      fill="#3f3d56"
      opacity="0.1"
    />
    <path
      d="M342.08,417.51c1.48-.94.89-3.46-.63-4.33s-3.41-.58-5.12-.24a2.09,2.09,0,0,0-1.1-2.2v-.38c1-1,.62-3-.6-3.88s-3.12-.92-4.76-.84a6.34,6.34,0,0,0-2-5.4,1.67,1.67,0,0,0-1.1-.53c-1,0-1.28,1.28-1.35,2.23a42.23,42.23,0,0,1-1.23,7.39l-31.08,52c-3.46,5,7.29-10,3.83-4.95a44,44,0,0,1-6.12,7.59,30.16,30.16,0,0,1-6.91,4.63,8.15,8.15,0,0,1-4.72-1.34,19,19,0,0,1-4.54-4.49,88.63,88.63,0,0,1-7.33-10.89,14.11,14.11,0,0,1-1.68-3.89c-.46-2.16,0-4.5-.85-6.53a10.67,10.67,0,0,0-1.34-2.12l-2.15-2.85v-.13c-.24-4.22-3.67-7.48-6.87-10.26-2.72-2.38-5.67-4.86-9.26-5.32-1.92-.25-3.89.12-5.81-.12-1.57-.2-3.06-.79-4.62-1.05a19.6,19.6,0,0,0-4.53-.09l-.64-.59a17.92,17.92,0,0,0,8.09-6.8c1.48-2.39,2.29-5.15,3.66-7.61,1.67-3,4.15-5.48,6-8.36,4.47-6.83,5.29-15.62,3.48-23.58s-6.05-15.19-11-21.64c-9.6-12.42-25.7-17-40.86-14.6-1,.16-2,.35-3,.57a38.52,38.52,0,0,0-7.43,2.37,19,19,0,0,0-8.11,6.33,14.61,14.61,0,0,0-1.41,2.62,15.43,15.43,0,0,0-.68,2.16,22.41,22.41,0,0,0-.37,6.76c.06.77.14,1.54.23,2.31l.15,1.16c.1.77.21,1.54.32,2.31.16,1.16.31,2.32.42,3.46a22,22,0,0,1,.13,2.43c0,.21,0,.41,0,.61a9.93,9.93,0,0,1-.27,1.79,7.5,7.5,0,0,1-.3.95,11.84,11.84,0,0,1-1.41,2.59,32.71,32.71,0,0,1-2.53,3.11l-.87,1c-.29.33-.57.67-.86,1a36.66,36.66,0,0,0-3.13,4.23,20.58,20.58,0,0,0-1.23,2.32,16.6,16.6,0,0,0-.71,1.86,15.4,15.4,0,0,0-.54,2.6c0,.22,0,.44-.06.66,0,.43,0,.87,0,1.31a11.47,11.47,0,0,0,.14,1.3,9.23,9.23,0,0,0,.3,1.26,8.55,8.55,0,0,0,.47,1.22c0,.11.1.22.16.33l.16.33c.11.22.22.43.32.65a4.26,4.26,0,0,1,.33,1c0,.11,0,.23,0,.35s0,.26,0,.38a4.09,4.09,0,0,1-1.48,2.55c-.2.19-.4.36-.61.54l-.32.26-.65.51-.62.5a12.59,12.59,0,0,0-1.51,1.5,55.87,55.87,0,0,0-16.74,1.64,22.64,22.64,0,0,1-6,1.09,3,3,0,0,1-2.6-1.09,3.83,3.83,0,0,1-.27-2.4,20.7,20.7,0,0,0-1.6-9.8,5.45,5.45,0,0,0-1.6-2.33,2.26,2.26,0,0,0-2.66-.14,24.93,24.93,0,0,1-.69,16.67,53.85,53.85,0,0,1-3.85,7.23c-2.28,3.89-3.56,8.34-5.59,12.37,2.27,7.69,1.76,15.9,3,23.84,1.11,7.39,3.69,14.47,6.28,21.48,2,5.29,4.08,10.81,8.32,14.53a7.58,7.58,0,0,0,5.15,2.24,9,9,0,0,0,4-1.52,15.67,15.67,0,0,0,3.39-2.49,8.76,8.76,0,0,0,1-1.33,5.19,5.19,0,0,0,.75,1.88c2.44-5.26,5.12-10.4,8-15.43a13.22,13.22,0,0,0,2.4-1.64c0,.18.09.36.14.54-.13.48-.25,1-.38,1.45s-.28.93-.42,1.38-.21.67-.32,1-.27.8-.42,1.2-.32.87-.49,1.3-.23.62-.36.92c-.31.76-.63,1.5-1,2.24a7,7,0,0,0,.86.35l.19.06a7,7,0,0,0,.79.2l.29,0a5.61,5.61,0,0,0,.59.06l.22,0H165a8.56,8.56,0,0,0,2.11-.36l.39,1.6a57.15,57.15,0,0,1,1.92,11c.19,4.2-.54,8.47.27,12.6.41,2.15,1.24,4.21,1.54,6.37a27.15,27.15,0,0,1-.11,6.11q-.7,7.36-1.4,14.73a12.6,12.6,0,0,1-1.26,5.2c-.69,1.2-1.81,2.57-1.11,3.76a25,25,0,0,1,3.51-.67c-.43,1.56-.82,3.13-1.19,4.71a8.3,8.3,0,0,0-.28,3.63c.25,1.14,1,2.17,1.08,3.33.18,1.8-1.07,3.39-1.76,5.06-1.76,4.26.11,9.06,2,13.28l5.52,12.52,4.53,10.27c1.34,3,2.69,6.1,4,9.18a298,298,0,0,1,14.42,43.24,5.16,5.16,0,0,0,.75,1.88c.76,1,2.15,1.32,3.28,1.94,3.39,1.87,3.78,7.45.68,9.77.63,7.52-5,14.79-7.9,21.75-6.68,16-5.47,34.06-7.76,51.26l2.59-1.51a3.21,3.21,0,0,1,.84.55q-.09.48-.21,1a15.67,15.67,0,0,1-1.66,4.17c-1.51,2.59-3.82,4.9-4.17,7.88-.21,1.8.34,3.6.33,5.41,0,.17,0,.33,0,.5-.23-.22-.58-.2-1.1.21a6.45,6.45,0,0,0-1.63,3.07c-.45,1.29-.81,2.6-1.17,3.91L180.71,763a53.71,53.71,0,0,1-2.71,8.15,34.92,34.92,0,0,0-2.4,5.52,17.13,17.13,0,0,0-.41,4.74,14.21,14.21,0,0,0,.65,4.5,11.18,11.18,0,0,0,6.55,6.21,30.75,30.75,0,0,0,9.1,1.72,7.65,7.65,0,0,0,2.39-.07,6.49,6.49,0,0,0,2.31-1.21c4.22-3.1,6.4-8.8,6.78-14a20.67,20.67,0,0,0-.57-3.18c.26-5.69-.57-11.41-.14-17.08.09.65.18,1.29.28,1.93l1,6.37a1.33,1.33,0,0,0-.34-.6,14.64,14.64,0,0,0-.38,7.29,43.5,43.5,0,0,0,2.1,7.07l1.36,3.8a9.07,9.07,0,0,0,1.62,3.15c1.19,1.31,3,1.8,4.74,2.22a52.25,52.25,0,0,0,11.48,2,2.6,2.6,0,0,0,1.51-.28,7.33,7.33,0,0,0,.68-.57,6.71,6.71,0,0,1,1.1-.64,7.26,7.26,0,0,0,3.52-4.17,6.58,6.58,0,0,0-.65-5.39,12.59,12.59,0,0,0-1.55-1.88l-6.84-7.25a43.1,43.1,0,0,0-3.34-3.54,1.25,1.25,0,0,0-1.1-.36c-1.86-4.64-1.62-10.06-1.3-15.15.1-1.52.93-4.67,1.26-7.26a11.71,11.71,0,0,0,3.63-2,5.48,5.48,0,0,0,2.09-3.12c3.45-17.62,9-34.7,14.24-51.87.52-1.69,1-3.39,1.53-5.08.22-.72.42-1.45.63-2.18s.35-1.18.52-1.77c.28-1,.56-2,.83-3,.08-.27.15-.54.23-.81a.94.94,0,0,1,0-.16c.33-1.23.65-2.46,1-3.69.12-.48.25-.94.37-1.42.39-1.56.78-3.14,1.15-4.71a5.18,5.18,0,0,0,.14-.66,2.79,2.79,0,0,0-.11-1.67v0h0a2.17,2.17,0,0,0-.39-.56c-.11-.13-.23-.26-.35-.38s-.26-.28-.38-.43a3.87,3.87,0,0,1-.7-1.31c0-.48,0-1,0-1.44s-.06-1-.09-1.52a16,16,0,0,1,.45-2c.12-.39.25-.78.37-1.17s.3-1,.46-1.45a3.67,3.67,0,0,0,.91-2.47q.93-2.32,2.05-4.55a13.72,13.72,0,0,0,1.83-4.92,19.52,19.52,0,0,0-.58-4.67c-1-6.5,2-12.83,4.21-19a84.27,84.27,0,0,0,3.72-14c.65-3.65,1.1-7.48,3.05-10.64a15.84,15.84,0,0,0,1.64-2.84,11.18,11.18,0,0,0,.44-3.22,35.53,35.53,0,0,1,3.15-12.77,8.1,8.1,0,0,0,.82-2.49.91.91,0,0,0,0-.17l0-.24.51-.08c.87-5.51,1.75-11.65,1.15-17.2a26.23,26.23,0,0,0-8.79-16.6l.1,0c1.72-.87,2.49-3,2.52-4.88a9.51,9.51,0,0,0-3.54-7.43,3.55,3.55,0,0,1-1.2-1.24,3.77,3.77,0,0,1-.15-1.61,8.23,8.23,0,0,0-5.07-7.64,1.91,1.91,0,0,1-.83-.48,2,2,0,0,1-.22-1.46,8.93,8.93,0,0,0-4.31-8.16c.4-2.14.8-4.38.19-6.48s-2.58-4-4.74-3.7c1.76-4.8-.74-10.14-.08-15.21.29-2.18,1.16-4.27,1.27-6.46.1-2-.39-4.14.58-5.88s3.26-3.1,2.67-5c-.25-.81-1-1.37-1.35-2.16s1.05-2,1.77-1.56c.34-.26.68-.53,1-.81a16.11,16.11,0,0,0,.6,3c.49,1.64,1.24,3.18,1.75,4.81.78,2.49,1,5.19,2.26,7.47,2,3.65,6.23,5.46,9.09,8.49,1.68,1.77,2.89,4,4.62,5.68a25.18,25.18,0,0,0,4.3,3.23l9.24,6a10.62,10.62,0,0,0,3.16,1.57,5.39,5.39,0,0,0,6.35-4.57,6.24,6.24,0,0,1-2.27-1.41c.13,0,.26,0,.39-.06a14.57,14.57,0,0,0,5.93-3.15c6.58-5.24,11.31-12.39,15.93-19.42,4.84-7.37,28.13-26.87,28.13-26.87v-7.9a28.44,28.44,0,0,0,7.76-6.61,8.57,8.57,0,0,0,1.95-5A4.45,4.45,0,0,0,342.08,417.51Zm-193.7,18.95q-.67,4.31-1.65,8.56a81.34,81.34,0,0,1-2.76,9.67l-.36,1c-.33-.62-.66-1.23-1-1.86-.75-1.57-1.36-3.2-2-4.83l-3.86-10.4c-.5-1.35-1-2.91-.25-4.15a4.64,4.64,0,0,1,2.2-1.65,43.48,43.48,0,0,1,8.46-2.87,23.17,23.17,0,0,0,2.72-.72A41,41,0,0,0,148.38,436.46Zm4.27-13a1.55,1.55,0,0,1,0-1.51,3.44,3.44,0,0,1,1-.7l.29-.2C153.54,421.88,153.09,422.68,152.65,423.49Zm8-11.31a20.92,20.92,0,0,0-3.08,3.16,33,33,0,0,0-2.64,4.08,3,3,0,0,0-1.1-3,6.37,6.37,0,0,1-1-.68,2.1,2.1,0,0,1,.42-2.94,6.1,6.1,0,0,1,3.11-1.06l4.61-.68C160.83,411.42,160.74,411.8,160.64,412.18ZM203.81,746.8a16.73,16.73,0,0,0-.27-4.13c.57,0,1.14,0,1.7,0C204.77,744,204.29,745.41,203.81,746.8Z"
      transform="translate(-33.81 -66.43)"
      fill="url(#e96273f1-ace8-4241-9189-48d1ceb051fa)"
    />
    <path
      d="M199.11,339.34c-8,1.29-16.9,4.37-20,11.87-2.31,5.67-.52,12.05.07,18.14a14,14,0,0,1-.17,4.83c-.66,2.57-2.48,4.65-4.24,6.64a35.21,35.21,0,0,0-6.09,8.54c-1.44,3.2-1.9,7-.41,10.2a7.35,7.35,0,0,1,1,2.69c.1,2.08-2.08,3.4-3.68,4.73-6,5-5.75,14-5.8,21.83A110.71,110.71,0,0,1,149.4,475a14.11,14.11,0,0,0,15.77-2.06,52.55,52.55,0,0,1-3.58,10.32c5.08,2.46,11.21-1.58,13.76-6.62s2.85-10.9,4.66-16.25,5-10,6.41-15.39c.45-1.78.73-3.68,1.82-5.16a13.58,13.58,0,0,1,3.2-2.73,31.23,31.23,0,0,0,11.31-15.33c6.22,1.37,12.57,2.75,18.91,2.17s12.82-3.45,16.17-8.87c1.48-2.39,2.28-5.14,3.65-7.6,1.68-3,4.15-5.48,6-8.35,4.46-6.83,5.28-15.6,3.47-23.56s-6-15.16-11-21.61C230.37,341.52,214.27,336.91,199.11,339.34Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <path
      d="M148.62,439.36c-.45,2.86-1,5.72-1.64,8.55a83.67,83.67,0,0,1-2.76,9.66,9.22,9.22,0,0,0-.87,4.44,8.07,8.07,0,0,0,1.07,2.64c3.65,6.49,8.59,12.76,9,20.2.1,1.85,0,3.86,1,5.39q4.23-9.11,9.34-17.76c3.56-6,7.52-12.14,8.54-19.08a35.75,35.75,0,0,0-.13-9.8c-.47-3.65-1.29-7.39-3.51-10.31-2.42-3.16-9-7.93-13.33-6.94C150.3,427.5,149.26,435.29,148.62,439.36Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M277.51,474.34c4.78-1.95,9.66-4,13.45-7.52a44,44,0,0,0,6.12-7.59L308.33,443c2.66-3.86,5.41-7.91,6-12.56a41.36,41.36,0,0,0,11.23-25.54c.08-.95.4-2.2,1.35-2.23a1.67,1.67,0,0,1,1.1.53,6.33,6.33,0,0,1,2,5.39c1.64-.08,3.42-.12,4.76.84s1.7,3.34.26,4.13a2.06,2.06,0,0,1,1.43,2.33c1.72-.34,3.61-.62,5.13.24s2.1,3.38.63,4.32a4.46,4.46,0,0,1,2.85,4.27,8.48,8.48,0,0,1-1.95,5c-4.32,5.8-11.94,8.14-16.95,13.36a40.37,40.37,0,0,0-4.41,5.89l-14.51,22.08c-4.61,7-9.34,14.17-15.92,19.39a14.57,14.57,0,0,1-5.93,3.15,6.53,6.53,0,0,1-6.23-1.73c-1.45-1.65-1.67-4-1.81-6.21C277.12,481.93,277.76,478.09,277.51,474.34Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
    <path
      d="M228.92,781a12.1,12.1,0,0,1,1.55,1.88,6.56,6.56,0,0,1,.65,5.38,7.19,7.19,0,0,1-3.51,4.16,6.41,6.41,0,0,0-1.11.64,6.3,6.3,0,0,1-.68.58,2.77,2.77,0,0,1-1.51.28,53.37,53.37,0,0,1-11.47-2c-1.72-.43-3.54-.92-4.74-2.22a9.07,9.07,0,0,1-1.62-3.15l-1.36-3.79a43.94,43.94,0,0,1-2.09-7.06,14.48,14.48,0,0,1,.38-7.28,2.29,2.29,0,0,1,.5,1.49,16.3,16.3,0,0,0,2.92,7.06,7.17,7.17,0,0,0,1.14,1.43,7.26,7.26,0,0,0,3.41,1.43,42.3,42.3,0,0,0,7.26.93,2,2,0,0,0,1-.12,1.79,1.79,0,0,0,.83-1,4.42,4.42,0,0,0,0-3c-.66-1.85-2.47-3.06-3.33-4.82-.65-1.3.24-2.73,1.56-1.63a41.57,41.57,0,0,1,3.35,3.54Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <path
      d="M216.35,754.73c-.39,6.11-.66,12.71,2.68,17.84,1.21,1.84,2.82,3.39,4.19,5.12a6.1,6.1,0,0,1,1.5,3.09c.19,2.24-1.91,4.16-4.12,4.58s-4.47-.28-6.61-1a15.92,15.92,0,0,1-5.61-2.64c-2.91-2.46-3.68-6.56-4.26-10.32l-1.36-8.74A20.9,20.9,0,0,1,204,749.46l2.24-6.56a3,3,0,0,1,1-1.63,2.78,2.78,0,0,1,1.71-.32c2.14.11,7.55.89,8.59,3.16C218.42,746.08,216.5,752.38,216.35,754.73Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
    <path
      d="M216.35,754.73c-.39,6.11-.66,12.71,2.68,17.84,1.21,1.84,2.82,3.39,4.19,5.12a6.1,6.1,0,0,1,1.5,3.09c.19,2.24-1.91,4.16-4.12,4.58s-4.47-.28-6.61-1a15.92,15.92,0,0,1-5.61-2.64c-2.91-2.46-3.68-6.56-4.26-10.32l-1.36-8.74A20.9,20.9,0,0,1,204,749.46l2.24-6.56a3,3,0,0,1,1-1.63,2.78,2.78,0,0,1,1.71-.32c2.14.11,7.55.89,8.59,3.16C218.42,746.08,216.5,752.38,216.35,754.73Z"
      transform="translate(-33.81 -66.43)"
      opacity="0.05"
    />
    <path
      d="M264.42,573.62a1.11,1.11,0,0,1,0,.17,7.49,7.49,0,0,1-.82,2.47A35.52,35.52,0,0,0,260.44,589a11.18,11.18,0,0,1-.44,3.22,16,16,0,0,1-1.64,2.83c-1.95,3.17-2.4,7-3.05,10.63a84,84,0,0,1-3.72,13.94c-2.23,6.18-5.23,12.5-4.21,19a19.52,19.52,0,0,1,.58,4.67,13.56,13.56,0,0,1-1.83,4.91q-1.12,2.22-2,4.55c-.65,1.66-1.23,3.36-1.74,5.08-.6,2.09-1,4.57.38,6.25a7.62,7.62,0,0,1,1.13,1.37,3.67,3.67,0,0,1,0,2.36q-1.19,5-2.54,10c-.7,2.6-1.44,5.18-2.2,7.76-5.62,18.87-12,37.55-15.76,56.88-.54,2.78-4.11,4.77-6.87,5.38a9,9,0,0,1-7.9-2.11c-.19-.17-.37-.36-.54-.54-2.9-3.12-3.33-7.91-3.11-12.23,1-19.89,11-38.1,15.76-57.43a111.1,111.1,0,0,0,3.1-21.32c1.11-24,1.56-49.38-5.23-72.45-1.41-4.8-3.08-10.22-.54-14.52,1.6-2.72,4.57-4.33,7.51-5.49a48.31,48.31,0,0,1,37.46,1,11.64,11.64,0,0,1-.06,1.44,14.76,14.76,0,0,0,.76,6.62A8.41,8.41,0,0,1,264.42,573.62Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <path
      d="M182.2,760.88l-1.27,4.62a52.36,52.36,0,0,1-2.7,8.13,34.92,34.92,0,0,0-2.4,5.52,17.13,17.13,0,0,0-.41,4.74,14.15,14.15,0,0,0,.65,4.49,11.15,11.15,0,0,0,6.54,6.2,30.48,30.48,0,0,0,9.1,1.71,7.36,7.36,0,0,0,2.39-.06,6.49,6.49,0,0,0,2.31-1.21c4.22-3.09,6.39-8.79,6.77-14a17.2,17.2,0,0,0-.71-3.58c-.33-.44-3.52,1.36-2.15,2.87,2,2.22-3.89,1.07-6.89.88a25.91,25.91,0,0,1-3.91-.64l-4.86-1c-1.59-.34-3.42-.89-4-2.41s.66-3.34,1.62-4.82c2.54-3.93,3.2-8.74,3.79-13.38.11-.91,1.25-6.82-1.1-5a6.63,6.63,0,0,0-1.63,3.07C182.91,758.26,182.55,759.57,182.2,760.88Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <path
      d="M242.72,664.09c-1.38-1.68-1-4.16-.37-6.25.22-.78.47-1.55.73-2.32L224,649.06c-.07,1.72-.15,3.42-.23,5.12a110.52,110.52,0,0,1-3.09,21.33c-4.77,19.32-14.78,37.53-15.76,57.41-.23,4.58.26,9.7,3.65,12.78a9,9,0,0,0,7.89,2.12c2.77-.61,6.33-2.61,6.88-5.39,3.78-19.33,10.13-38,15.76-56.89q2.63-8.79,4.74-17.72a3.64,3.64,0,0,0,0-2.35A7,7,0,0,0,242.72,664.09Z"
      transform="translate(-33.81 -66.43)"
      opacity="0.05"
    />
    <path
      d="M190,739.92c-1.51,2.6-3.81,4.9-4.16,7.88-.21,1.79.34,3.59.33,5.4a17.55,17.55,0,0,1-.79,4.41q-2.79,10.07-6.42,19.86a5.45,5.45,0,0,0-.51,2.7c.24,1.53,1.73,2.54,3.15,3.15,4.55,1.94,9.67,1.81,14.61,1.61a7.67,7.67,0,0,0,4.11-1c1.77-1.21,2.21-3.6,2.32-5.74.34-6.2-.71-12.43,0-18.59.25-2.25.72-4.46,1.07-6.69.49-3.1.74-6.36-.28-9.33a21.39,21.39,0,0,0-3.5-5.87,18.45,18.45,0,0,0-4.85-4.84c-.58-.34-2.23-1.4-2.82-.74-.3.34-.17,1.25-.21,1.67a17.51,17.51,0,0,1-.34,1.92A15.83,15.83,0,0,1,190,739.92Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
    <path
      d="M226.66,581.36c-.89,1.21-.71,2.89-.35,4.35.63,2.64,1.69,5.17,2.55,7.74a107.7,107.7,0,0,1,3.28,14.08c.8,4.3,2.5,9.09,1.81,13.42a95.62,95.62,0,0,1,10.13,31.81c.39,2.85-5.94,6.53-5.82,9.4.24,5.72,4.8,6.18,1.44,10.74-.17.23,1.26,5.34,1.07,5.56-1.37,1.65-3.11,3-4.58,4.51a34.67,34.67,0,0,0-4.83,7.07c-8.7,15.72-21.28,33.54-17.4,51.09a3.11,3.11,0,0,1-1.66,3.15,8.6,8.6,0,0,1-3.68.85l-.6,0c-2.9-3.12-3.33-7.91-3.11-12.23,1-19.89,11-38.1,15.76-57.43a111.1,111.1,0,0,0,3.1-21.32c1.11-24,1.56-49.38-5.23-72.45-1.41-4.8-3.08-10.22-.54-14.52,1.6-2.72,4.57-4.33,7.51-5.49a48.31,48.31,0,0,1,37.46,1,11.64,11.64,0,0,1-.06,1.44,14.76,14.76,0,0,0,.76,6.62,8.41,8.41,0,0,1,.75,2.88s.34-3.87.33-3.81C257,570.93,248.82,576,241,577.15a55.43,55.43,0,0,0-11.91,2.62A5.36,5.36,0,0,0,226.66,581.36Z"
      transform="translate(-33.81 -66.43)"
      opacity="0.05"
    />
    <path
      d="M172.67,538.78q-1.57,5-2.77,10.1a8.45,8.45,0,0,0-.28,3.63c.25,1.14,1,2.16,1.08,3.32.18,1.8-1.07,3.39-1.76,5.06-1.76,4.25.12,9.05,2,13.26l5.52,12.5L181,596.91c1.35,3.05,2.69,6.1,4,9.17a297.33,297.33,0,0,1,14.41,43.19,5.32,5.32,0,0,0,.74,1.88c.77,1,2.16,1.32,3.28,1.94,3.4,1.86,3.79,7.44.68,9.76.64,7.51-5,14.76-7.89,21.72-6.68,16-5.47,34-7.76,51.2l2.59-1.52c2.49,1.14,2.4,4.67,3.74,7.06,2,3.59,6.92,4.09,11,3.82a8.52,8.52,0,0,0,3.67-.85,3.1,3.1,0,0,0,1.66-3.15c-3.87-17.55,8.7-35.37,17.41-51.09a34.63,34.63,0,0,1,4.82-7.07c1.48-1.56,3.21-2.87,4.59-4.51,3.84-4.61,4.33-11.11,4.07-17.11a95.78,95.78,0,0,0-10.9-40.41c.7-4.32-1-9.11-1.8-13.41A105.27,105.27,0,0,0,226,593.46c-.86-2.59-1.91-5.11-2.55-7.75-.35-1.46-.54-3.14.35-4.35a5.39,5.39,0,0,1,2.46-1.59,55.43,55.43,0,0,1,11.91-2.62L265,573.3c.86-5.51,1.74-11.65,1.14-17.19A26.43,26.43,0,0,0,247.21,534c-1.17-.31-2.54-.51-3.5.23A139.6,139.6,0,0,0,172.67,538.78Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <path
      d="M197,393.87a13.17,13.17,0,0,1-1.17,7.68,12.06,12.06,0,0,1-3,3.37,23,23,0,0,1-8.84,4.39c-1.9.48-4,.8-5.29,2.31-1.88,2.27-.62,5.71,1,8.19,2.78,4.32,6.64,8.23,11.59,9.58,4,1.08,8.17.42,12.21,1.12,2.93.51,5.69,1.72,8.58,2.41a25.34,25.34,0,0,0,23.27-6.49c-4.3-3.3-8.76-6.81-11-11.75a16.67,16.67,0,0,1-.84-11.24c1-3.66,3.35-7.22,2.63-11s-4.4-6.31-8-7.57A52.2,52.2,0,0,0,208,382.86c-1.89-.26-13.89-2.91-14.64-1.6-.42.74,2.07,5.12,2.38,6.09A23.16,23.16,0,0,1,197,393.87Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
    <circle cx="178.32" cy="311.86" r="24.34" fill="#ee8e9e" />
    <path
      d="M199.27,418.52l16.51,2.78a61.77,61.77,0,0,0,12.33,1.24,34.35,34.35,0,0,1,6.8,0c1.56.26,3.05.85,4.61,1.05,1.93.24,3.89-.13,5.82.12,3.58.46,6.53,2.94,9.25,5.31,3.19,2.78,6.62,6,6.87,10.25a3.11,3.11,0,0,1-.2,1.42,4.17,4.17,0,0,1-1.23,1.28c-3,2.49-4.73,6.2-6.89,9.48a36.53,36.53,0,0,1-8.2,8.85c-.72-.46-2.09.75-1.78,1.55s1.1,1.35,1.36,2.16c.59,1.87-1.72,3.25-2.68,5s-.47,3.88-.57,5.87c-.12,2.19-1,4.28-1.27,6.45-.67,5.07,1.84,10.41.07,15.2,2.17-.27,4.13,1.6,4.74,3.69s.22,4.34-.19,6.48a8.91,8.91,0,0,1,4.32,8.14,1.4,1.4,0,0,0,1,1.94,8.24,8.24,0,0,1,5.07,7.63,3.82,3.82,0,0,0,.15,1.62,3.58,3.58,0,0,0,1.19,1.23,9.48,9.48,0,0,1,3.54,7.42c0,1.93-.8,4-2.51,4.87-3.5,1.78-7.25,2.47-11.09,3.3a97.58,97.58,0,0,1-10.73,1.91,98.85,98.85,0,0,1-10,.31l-22.08-.09c-6.21,0-12.42,0-18.61-.47-5.78-.39-11.69-1.11-17.29.41-.7-1.19.42-2.56,1.11-3.75a12.48,12.48,0,0,0,1.26-5.2l1.4-14.71a27.07,27.07,0,0,0,.11-6.1c-.3-2.17-1.12-4.22-1.54-6.37-.8-4.12-.07-8.38-.26-12.58a57.61,57.61,0,0,0-1.93-11l-4.38-18c-.7-2.89-1.07-6.25-2.15-9q-5.05-13-10.59-25.72a2.73,2.73,0,0,1,.2-2.28l3.65-6.54a41.39,41.39,0,0,1,3.34-5.33,21,21,0,0,1,12.32-7.56,21.72,21.72,0,0,1,14.33,2.12c1.7.91,3.28,2,5,2.9C192.4,417.2,196,418.74,199.27,418.52Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M257.85,434.55l5.75,7.67a10.67,10.67,0,0,1,1.34,2.12c.86,2,.39,4.36.85,6.51a13.72,13.72,0,0,0,1.69,3.89,87.5,87.5,0,0,0,7.31,10.87,18.83,18.83,0,0,0,4.55,4.49,7.48,7.48,0,0,0,6.12,1.09,3.77,3.77,0,0,0-2,1.82c-2.19,4.34-2.35,9.48-1.42,14.24a14.4,14.4,0,0,0,1.6,4.66,6.92,6.92,0,0,0,3.66,3.17,5.38,5.38,0,0,1-6.35,4.56,10.33,10.33,0,0,1-3.15-1.57l-9.24-6a25.71,25.71,0,0,1-4.3-3.23c-1.73-1.72-2.93-3.9-4.61-5.67-2.86-3-7.06-4.84-9.08-8.48-1.27-2.28-1.49-5-2.27-7.46-.51-1.63-1.26-3.17-1.75-4.81-1.52-5.06-.42-10.61,1.89-15.36S254.43,438.59,257.85,434.55Z"
      transform="translate(-33.81 -66.43)"
      fill="#60a5fa"
    />
    <path
      d="M236.18,364.41a32.26,32.26,0,0,0-8.56-8.91c-4.55-3.39-9.78-6.21-15.45-6.53a16.72,16.72,0,0,0-6.95,1.13c-.11-6.87-1.81-11.45-6.11-10.76-8,1.29-16.9,4.37-20,11.87-2.31,5.67-.52,12.05.07,18.14a14,14,0,0,1-.17,4.83c-.66,2.57-2.48,4.65-4.24,6.64a35.21,35.21,0,0,0-6.09,8.54c-1.44,3.2-1.9,7-.41,10.2a7.35,7.35,0,0,1,1,2.69c.1,2.08-2.08,3.4-3.68,4.73-6,5-5.75,14-5.8,21.83A110.71,110.71,0,0,1,149.4,475a14.11,14.11,0,0,0,15.77-2.06,52.55,52.55,0,0,1-3.58,10.32c5.08,2.46,11.21-1.58,13.76-6.62s2.85-10.9,4.66-16.25,5-10,6.41-15.39c.45-1.78.73-3.68,1.82-5.16a13.58,13.58,0,0,1,3.2-2.73c5.24-3.76-2.48-32.25-.43-38.37,3,.67,8.65-14,11.84-29a15.1,15.1,0,0,0,6.93.69,8.58,8.58,0,0,1,2.47-.17,6.36,6.36,0,0,1,2.16.88,54.67,54.67,0,0,0,7.38,3.79c5.28,2,11.08,1.71,16.71,1.43A16.65,16.65,0,0,0,236.18,364.41Z"
      transform="translate(-33.81 -66.43)"
      fill="#303d5c"
    />
    <g opacity="0.1">
      <path
        d="M152.26,475a110.41,110.41,0,0,0,10.44-46.15c.05-7.8-.21-16.86,5.8-21.83,1.6-1.33,3.78-2.65,3.68-4.73a7.51,7.51,0,0,0-1-2.69c-1.49-3.18-1-7,.4-10.2a35,35,0,0,1,6.1-8.54c1.75-2,3.58-4.07,4.23-6.64a14.22,14.22,0,0,0,.18-4.83c-.6-6.09-2.38-12.47-.07-18.14,3-7.26,11.39-10.37,19.19-11.73a4.39,4.39,0,0,0-2.1-.14c-8,1.29-16.9,4.37-20,11.87-2.31,5.67-.52,12.05.07,18.14a14,14,0,0,1-.17,4.83c-.66,2.57-2.48,4.65-4.24,6.64a35.21,35.21,0,0,0-6.09,8.54c-1.44,3.2-1.9,7-.41,10.2a7.35,7.35,0,0,1,1,2.69c.1,2.08-2.08,3.4-3.68,4.73-6,5-5.75,14-5.8,21.83A110.71,110.71,0,0,1,149.4,475a13.68,13.68,0,0,0,7.73,1.45A13.2,13.2,0,0,1,152.26,475Z"
        transform="translate(-33.81 -66.43)"
      />
      <path
        d="M164.45,483.22A52.55,52.55,0,0,0,168,472.9a13.34,13.34,0,0,1-3.46,2.29,52.32,52.32,0,0,1-3,8,7.6,7.6,0,0,0,4.7.6A7.47,7.47,0,0,1,164.45,483.22Z"
        transform="translate(-33.81 -66.43)"
      />
      <path
        d="M208.08,350.1a16.77,16.77,0,0,1,4.64-1.08l-.55,0a16.29,16.29,0,0,0-4.11.31C208.07,349.55,208.08,349.82,208.08,350.1Z"
        transform="translate(-33.81 -66.43)"
      />
      <path
        d="M224.65,374.9a54.55,54.55,0,0,1-7.37-3.79,6.4,6.4,0,0,0-2.17-.88,7.49,7.49,0,0,0-2.26.14,9.26,9.26,0,0,1,1.56.74,54.67,54.67,0,0,0,7.38,3.79,33,33,0,0,0,12.34,1.6A28.94,28.94,0,0,1,224.65,374.9Z"
        transform="translate(-33.81 -66.43)"
      />
      <path
        d="M205.71,369.71c0,.22-.09.44-.14.66a15.12,15.12,0,0,0,3.62.1A16,16,0,0,1,205.71,369.71Z"
        transform="translate(-33.81 -66.43)"
      />
    </g>
    <path
      d="M155.05,482.59a8.94,8.94,0,0,1-2.4,7.11,15.76,15.76,0,0,1-3.39,2.49,9,9,0,0,1-4,1.51,7.61,7.61,0,0,1-5.14-2.23c-4.24-3.72-6.36-9.23-8.32-14.52-2.59-7-5.17-14.07-6.28-21.46-1.19-7.92-.68-16.12-2.95-23.81,2-4,3.3-8.46,5.59-12.34a57.47,57.47,0,0,0,3.85-7.22,25,25,0,0,0,.68-16.66,2.26,2.26,0,0,1,2.66.14,5.51,5.51,0,0,1,1.6,2.33,20.66,20.66,0,0,1,1.6,9.79,3.8,3.8,0,0,0,.27,2.39,3,3,0,0,0,2.6,1.1,23.47,23.47,0,0,0,6-1.09,55.75,55.75,0,0,1,18.51-1.53,8.93,8.93,0,0,1,3.61.88,3.36,3.36,0,0,1,1.86,3l-14.8,2.17a6.1,6.1,0,0,0-3.11,1.06,2.1,2.1,0,0,0-.42,2.93,6.87,6.87,0,0,0,1,.68,3,3,0,0,1-.12,4.87,3.44,3.44,0,0,0-1,.7c-.6.81.2,1.88.46,2.86a3.61,3.61,0,0,1-1.78,3.69,12.37,12.37,0,0,1-4.13,1.39,44.3,44.3,0,0,0-8.45,2.87,4.64,4.64,0,0,0-2.2,1.65c-.73,1.24-.25,2.8.25,4.15l3.86,10.38c.6,1.63,1.21,3.26,2,4.83,1,2,2.19,3.94,3.2,6s1.67,3.85,2.41,5.81C150.5,473.8,154.39,477,155.05,482.59Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
    <rect
      x="254.79"
      y="348.82"
      width="46.13"
      height="44.66"
      fill="url(#fa251bcb-f561-47ff-8b25-b5a12635a0f6)"
    />
    <rect x="255.59" y="349.59" width="44.54" height="43.12" fill="#7cfcff" />
    <path
      d="M326.22,412.62a4.6,4.6,0,0,0-1.69,2.47,1,1,0,0,0,.39,1.12,1.12,1.12,0,0,0,.68,0,6.35,6.35,0,0,0,3-1.41,3,3,0,0,0-.89.72,1,1,0,0,0-.12,1.08,1.41,1.41,0,0,0,1,.51,9.57,9.57,0,0,0,4.29-.2,5.89,5.89,0,0,0-1.78,1.05,2.39,2.39,0,0,0-.81,1.85.92.92,0,0,0,.32.69,1.15,1.15,0,0,0,.48.17,11.56,11.56,0,0,0,4,0,2.05,2.05,0,0,0,1.68-1,2.52,2.52,0,0,0-.39-1.93,10.79,10.79,0,0,1-1-4.88,1.92,1.92,0,0,0-.14-1,1.78,1.78,0,0,0-.89-.65c-1.41-.62-3.33-1.48-4.9-1A10.31,10.31,0,0,0,326.22,412.62Z"
      transform="translate(-33.81 -66.43)"
      fill="#ee8e9e"
    />
  </svg>
)

export default Schedule
